/** SceneManager keeps track of an dictionary of scenes */
import kontra from 'kontra';

const { on, emit } = kontra;

export default class SceneManager {
  constructor () {
    this.scenes = {};
    this.currentSceneName = '';

    // Subscribe to scene change events
    on('scene-change', (newScene) => {
      this.switchScene(newScene);
    });
  }

  /** Adds a scene to the sceneManager.
     * If it's the first one, also sets the current scene to point to it.
     */
  addScene (name, scene) {
    this.scenes[name] = scene;
    scene.onExit();
  }

  get currentScene () {
    return this.scenes[this.currentSceneName];
  }

  getScene (name) {
    return this.scenes[name];
  }

  switchScene (name) {
    // cleanup old scene
    if (this.currentScene) {
      this.log(`Exiting scene ${this.currentSceneName}`);
      this.currentScene.onExit();
    }
    // start new scene
    this.currentSceneName = name;
    this.log(`Entering scene ${this.currentSceneName}`);
    this.currentScene.onEnter();
  }

  log (msg) {
    console.log(`[${this.constructor.name}: ${msg}]`);
  }

  update () {
    this.currentScene.update();
  }

  render () {
    this.currentScene.render();
  }
}
